import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { useApplicationPageAggregatedData } from "./aggregatedData";
export function useApplicationPagePermissions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(data) {
        var result = data.included.find(function (item) {
          return item.type === 'user_permissions';
        });
        if (!result) {
          throw new Error('Could not find user_permissions in the response');
        }
        return result.attributes.permissions;
      },
      onError: options.onError
    }),
    data = _useApplicationPageAg.data,
    isError = _useApplicationPageAg.isError,
    isFetched = _useApplicationPageAg.isFetched;
  if (!data) {
    throw new Error('Permissions not found in aggregated data.');
  }
  return {
    permissions: data,
    isError: isError,
    isFetched: isFetched
  };
}